import React, { Component } from 'react'
import { Button, Divider, Drawer, Form, Input, message, Select } from 'antd'
import { v4 as uuid } from 'uuid'
import { KioskContextData } from '../../../../../context/KioskContext'
import IBranch from '../../../../../interfaces/IBranch'
import { KioskCreateRequest } from '../../../../../services/api/interfaces/ApiRequest'

type RegisterKioskProps = {
  branch: IBranch

  kioskContext: KioskContextData

  onClose: (finished?: boolean) => void
}

export default class RegisterKiosk extends Component<RegisterKioskProps> {

  state = {
    visible: false,
    saving: false
  }

  componentDidMount() {
    const { branch } = this.props

    this.setState({
      visible: !!branch
    })
  }

  private handleClose = (finished?: boolean) => {
    this.setState({
      visible: false
    }, () => {
      setTimeout(() => {
        this.props.onClose(finished)
      }, 500)
    })
  }

  private handleSave = async (values: any) => {
    const { branch, kioskContext } = this.props

    try {
      this.setState({
        saving: true
      })

      const payload: KioskCreateRequest = {
        kiosk: {
          ...values,
          fingerprint: uuid(),
          branch_uuid: branch.uuid
        }
      }
  
      await kioskContext.requestKioskCreate(payload)
      this.handleClose(true)
      message.success('Kiosk created successfully!')
    } catch (error) {
      message.error(`Failed to create kiosk. Reason: ${error}`)
    } finally {
      this.setState({
        saving: false
      })
    }
  }

  render() {
    const { branch } = this.props
    const { visible, saving } = this.state

    return (
      <Drawer
        title={`${branch.name} - New Kiosk`}
        width={320}
        closable={false}
        visible={visible}
        onClose={() => this.handleClose()}
      >
        <Form
          name="organization_kiosk"
          layout="vertical"
          initialValues={{
            type_key: 'SELF_CHECK_IN'
          }}
          onFinish={this.handleSave}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Name is required'
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Type"
            name="type_key"
            rules={[
              {
                required: true,
                message: 'Type is required'
              }
            ]}
          >
            <Select
              options={[
                {
                  value: 'SELF_CHECK_IN'
                }
              ]}
            />
          </Form.Item>

          <Divider />

          <Button
            type="primary"
            htmlType="submit"
            loading={saving}
            block
          >
            Save
          </Button>
        </Form>
      </Drawer>
    )
  }
}
